import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useExamStatus } from './ExamStatusContext';

const withResetOnNavigation = (WrappedComponent) => {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const previousPath = useRef(location.pathname); // 前のパスを記録
    const { resetStatus } = useExamStatus();

    useEffect(() => {
      // 履歴が変わった場合に動作
      if (location.pathname !== previousPath.current) {
        if (window.history.state && window.history.state.idx < previousPath.current) {
          resetStatus(); // 状態をリセット
          navigate('/start'); // GATBstart.js に戻る
        }
        previousPath.current = location.pathname; // 更新
      }
    }, [location, navigate, resetStatus]);

    return <WrappedComponent {...props} />;
  };
};

export default withResetOnNavigation;
